import React, { useEffect, useState } from "react";
import ReactSwitch from "react-switch";
import { AppConstatnt } from "../../Utils/AppConstant";
import { getTheme } from "../../Utils/Utility";
import LanguageSelection from "../LanguageSelection/LanguageSelection";
import './Settings.css';
import { injectIntl } from 'react-intl';

function Settings({ intl, open = false, onButtonClick, onThemeChange }) {
    const [show, setShow] = useState(open);
    const [checked, setChecked] = useState();
    const { formatMessage } = intl;

    useEffect(() => {
        if (getTheme() === AppConstatnt.theme.LIGHT) {
            setChecked(true);
        }

    }, [])


    const handleClose = () => {
        setShow(false);
        onButtonClick();
    }

    const handleSwitch = (check) => {
        setChecked(check);
        onThemeChange();
    }



    return (
        <>
            {show &&
                <>
                    <div className='right-bar'>
                        <div className="rightbar-title">

                            <a role="button" className="right-bar-toggle float-right" onClick={handleClose}>
                                <i className="fa fa-times"></i>
                            </a>
                            <h5 className="m-0">{formatMessage({ id: "app.settings" })}</h5>
                        </div>
                        {getTheme() === AppConstatnt.theme.DARK && <hr className="mt-0" />}
                        <h5 className="mt-3 settings-tittle">{formatMessage({ id: "app.color_scheme" })}</h5>
                        <div className="colorScheme">
                            <label htmlFor="material-switch">
                                <span style={{ padding: '0 .5rem 0 1.5rem' }}>{formatMessage({ id: "app.light_theme" })}</span>
                                <ReactSwitch
                                    onChange={handleSwitch}
                                    checked={checked}
                                    onColor="#86d3ff"
                                    onHandleColor="#2693e6"
                                    handleDiameter={30}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    //className="custom-control-input"
                                    height={20}
                                    width={48}
                                    handleDiameter={18}
                                    id="material-switch" />

                            </label>
                        </div>

                        <hr className="mt-1" />
                        <LanguageSelection />
                    </div>
                    <div class="rightbar-overlay"></div>
                </>
            }

        </>
    )


}

export default injectIntl(Settings);